import "./scss/main.scss";
import {initBurgerMenu} from "./script/burgermenu";
import {initSwiper} from "./script/swiper";

const handler = () => {
    // Handler implementation
    console.log('Handler executed');
    initBurgerMenu();
    initSwiper();
};

const runHandler = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handler);
    } else {
        handler();
    }
};

runHandler();
